import {Field} from 'commons/models';
import {EfeUser} from 'commons/types/Types';

// inactividad en ms
export const IDLE_TIME = 300_000;

export const ATTR_NULL = 'attrNameNull';
export const DOB_ATTR = 'birthDate';
export const MIN_AGE = 18;
export const CONSIGNEES_NAME = 'Consignatarios';
export const CONSIGNEE_NAME = 'Consignatario';
export const CONSIGNEES_PER_PAGE = 10;
export const ADMIN_ID_SALESFORCE = '0';
export const TABLE_PER_PAGE = 10;
export const IMAGE_PREFIX = 'data:image/jpeg;base64,';
export const IMAGE_PREFIX_PNG = 'data:image/png;base64,';
export const DNI_FRONT = 'DNI_FRONT';
export const DNI_BACK = 'DNI_BACK';

export const USER_DATA: EfeUser = {
    username: '',
    idSalesforce: '',
    email: '',
    fullName: '',
    loggedIn: false,
    tokenType: '',
    token: '',
    isMigrated: false,
    contractService: false,
    expires: 0,
    refreshToken: '',
    pendingActions: [''],
    expirationDate: null,
    logout: false,
    isAdmin: false,
};

export enum StatusTitles {
    AVISO = '¡AVISO!',
    LISTO = '¡LISTO!',
}

export enum StatusRegisterMessages {
    COMMON_ERROR = 'Contrato en proceso.',
    CONTRACT_IN_REVISION = 'Tu contrato est\u00E1 en revisi\u00F3n, te contactaremos en breve.',
    PROCESS_OK = 'Tu cuenta se registr\u00F3 exitosamente.',
}

export enum ConsigneeRadioValues {
    TRUE = 'true',
    FALSE = 'false',
}

export enum AlertActions {
    OK = 'ok',
    CANCEL = 'cancel',
    ACCEPT = 'accept',
}

export enum AllowedOtpTypes {
    ALPHA = 'alpha',
    NUMERIC = 'numeric',
    ALPHANUMERIC = 'alphanumeric',
}

export enum AnalyticsCategories {
    LOGIN = 'Login',
    LOGOUT = 'Logout',
    USER = 'User',
    AML = 'AML',
    SEND = 'Send',
    ERROR = 'Error',
    KYC = 'Onboarding KYC',
}

export enum Constants {
    ACCOUNT_STATUS_OK = 'OK',
    AML_AUTHORIZED_ID = '5',
    AML_ONBOARDING_ID = '8',
    CLIENT = 'CL',
    LEGAL_REPRESENTATIVE = 'RL',
    MODULE_STEP = 'MODULE_STEP',
    CAT_SEPOMEX = 'CAT_SEPOMEX',
    DOC_TERMS = 'DOC_CONDICIONES',
    DOC_PRIVACY = 'DOC_PRIVACIDAD',
    DOC_MANUAL = 'DOC_SYSTEM_MANUAL',
    DOC_ARTICLE_58 = 'DOC_CONTRATO',
    DOC_CONTRACT = 'DOC_CONTRATO',
    DOC_CONTRATO_CL_PDF = 'DOC_CONTRATO_CL_PDF',
    DOC_CONTRATO_CT_PDF = 'DOC_CONTRATO_CT_PDF',
    DOC_CONTRACT_PREVIEW = 'DOCTO_CONTRATO_PREVIEW',
    DOC_REAL_ID = 'DOC_IDENTIFICACION_REAL',
    DATE_FORMAT = 'dd/MM/yyyy',
    ATTR_NULL = 'attrNameNull',
    DOC_DNI_BACK = 'DOC_DNI_BACK',
    DOC_DNI_BACK_RL = 'DOC_DNI_BACK_RL',
    DOC_DNI_BACK_CL = 'DOC_DNI_BACK_CL',
    DOC_DNI_BACK_PR = 'DOC_DNI_BACK_PR',
    DOC_DNI_FRONT = 'DOC_DNI_FRONT',
    DOC_DNI_FRONT_RL = 'DOC_DNI_FRONT_RL',
    DOC_DNI_FRONT_CL = 'DOC_DNI_FRONT_CL',
    DOC_DNI_FRONT_PR = 'DOC_DNI_FRONT_PR',
    DOC_FIRMA = 'DOC_FIRMA',
    DOC_FIRMA_FINAL = 'DOC_FIRMA_FINAL',
    DOC_FIRMA_MIGRADO = 'DOC_FIRMA_MIGRADO',
    DOC_CEDULA_FISCAL = 'DOC_CEDULA_FISCAL',
    DOC_FIRMA_DIGITALIZADA = 'DOC_FIRMA_DIGITALIZADA',
    DOC_FIRMA_DIGITALIZADA_CT = 'DOC_FIRMA_DIGITALIZADA_CT',
    DOC_COMP_DOMICILIO = 'DOC_COMP_DOMICILIO',
    DOC_ACTA_CONSTITUTIVA = 'DOC_ACTA_CONSTITUTIVA',
    CAPTURE_DNI_FRONT = 'CAPTURE_DNI_FRONT',
    CAPTURE_DNI_BACK = 'CAPTURE_DNI_BACK',
    CONFIRM_DNI_FRONT = 'CONFIRM_DNI_FRONT',
    CONFIRM_DNI_BACK = 'CONFIRM_DNI_BACK',
    GUIA_PROPIETARIO_REAL = 'GUIA_PROPIETARIO_REAL',
    DOC_LAYOUT_SECONDARY_CLIENT = 'DOC_LAYOUT_SECONDARY_CLIENT',
    DOC_PRIVACIDAD= 'DOC_PRIVACIDAD'
}

export enum SnackbarVariants {
    INFO = 'info',
    ERROR = 'error',
    DEFAULT = 'default',
    SUCCESS = 'success',
    WARNING = 'warning',
}

export enum Roles {
    CLIENT = 'CL',
    LEGAL_REPRESENTATIVE = 'RL',
    REAL_OWNER = 'PR',
    SHAREHOLDER = 'AC',
    BENEFICIARY = 'BE',
}

export enum ViewKeys {
    // Datos y documentacion
    DATA_DOCUMENTATION_INFO = 'DATA_DOCUMENTATION_INFO',
    DATA_DOCUMENTATION_CONST_ACT = 'DATA_DOCUMENTATION_CONST_ACT',
    DATA_DOCUMENTATION_ID = 'DATA_DOCUMENTATION_ID',
    DATA_DOCUMENTATION_TAX_ID = 'DATA_DOCUMENTATION_TAX_ID',
    DATA_DOCUMENTATION_BIOMETRIC = 'DATA_DOCUMENTATION_BIOMETRIC',
    DATA_DOCUMENTATION_SIGNATURE = 'DATA_DOCUMENTATION_SIGNATURE',

    // Domicilio fiscal
    FISCAL_LOCATION_INFO = 'FISCAL_LOCATION_INFO',
    FISCAL_LOCATION_ADDRESS = 'FISCAL_LOCATION_ADDRESS',

    // Perfil transaccional
    TRANSACTIONAL_INFO = 'TRANSACTIONAL_INFO',

    // Representante legal
    LEGAL_PERSONAL_INFO = 'LEGAL_PERSONAL_INFO',
    LEGAL_OFFICIAL_INFO = 'LEGAL_OFFICIAL_INFO',
    LEGAL_IDENTIFICATION = 'LEGAL_IDENTIFICATION',
    LEGAL_ATTORNEY_POWER = 'LEGAL_ATTORNEY_POWER',
    LEGAL_SIGNATURE = 'LEGAL_SIGNATURE',
    LEGAL_ADDITIONAL_INFO = 'LEGAL_ADDITIONAL_INFO',

    // Beneficiarios
    BENEFICIARY_INFO = 'BENEFICIARY_INFO',
    BENEFICIARY_ADDRESS = 'BENEFICIARY_ADDRESS',

    // Accionistas
    SHAREHOLDER_PHYSICAL_INFO = 'SHAREHOLDER_PHYSICAL_INFO',
    SHAREHOLDER_MORAL_INFO = 'SHAREHOLDER_MORAL_INFO',
    SHAREHOLDER_REPRESENTATIVE = 'SHAREHOLDER_REPRESENTATIVE',

    // Propietario real
    REAL_OWNER_PERSONAL_INFO = 'REAL_OWNER_PERSONAL_INFO',
    REAL_OWNER_LOCATION_INFO = 'REAL_OWNER_LOCATION_INFO',
    REAL_OWNER_IDENTIFICATION_INFO = 'REAL_OWNER_IDENTIFICATION_INFO',

    // Terminos y condiciones
    V_FIRMA_TERMINOS_CONDICIONES = 'V_FIRMA_TERMINOS_CONDICIONES',
    V_FIRMA_TERMINOS_CONDICIONES_MIGRADO = 'V_FIRMA_TERMINOS_CONDICIONES_MIGRADO',

    // Consignee
    V_CONSIGNEE_INFO = 'V_CONSIGNATARIOS_DATOS_GENERALES',
    V_CONSIGNEE_ADDRESS = 'V_CONSIGNATARIOS_DATOS_DOMICILIO',
    V_CONSIGNEE_SIGN = 'V_CONSIGNEE_SIGN'
}

export enum PersonTypes {
    MORAL = '2',
    FISICA = '1',
    FISICA_ACTIVIDAD_EMPRESARIAL = '3',
}

export enum HttpCodes {
    OK = '200',
    BAD_REQUEST = '400',
    UNAUTHORIZED = '401',
    FORBIDDEN = '403',
    NOT_FOUND = '404',
    CONFLICT = '409',
    INTERNAL_SERVER_ERROR = '500',
}

export const TEMP_ADDRESS_FIELDS: Array<Field> = [
    {
        fieldId: 73,
        idOrder: 1,
        label: 'Calle',
        gridSize: 12,
        attrName: 'addressDescriptionNat',
        typeElement: 'TEXT',
        required: true,
        hidden: false,
        disable: false,
        catalog: null,
        catalogValues: [],
        variant: undefined,
        validations: [
            {
                value: '50',
                typeValidation: 'VAL_LENGTH_MAX',
                errorMessage: 'La longitud m\u00E1xima debe de ser de 50 caracteres',
            },
        ],
    },
    {
        fieldId: 74,
        idOrder: 2,
        label: 'N\u00FAmero exterior',
        gridSize: 4,
        attrName: 'outdoorNumberNat',
        typeElement: 'TEXT',
        required: true,
        hidden: false,
        disable: false,
        catalog: null,
        catalogValues: [],
        variant: undefined,
        validations: [
            {
                value: '50',
                typeValidation: 'VAL_LENGTH_MAX',
                errorMessage: 'La longitud m\u00E1xima debe de ser de 50 caracteres',
            },
        ],
    },
    {
        fieldId: 75,
        idOrder: 3,
        label: 'N\u00FAmero interior',
        gridSize: 4,
        attrName: 'interiorNumberNat',
        typeElement: 'TEXT',
        required: false,
        hidden: false,
        disable: false,
        catalog: null,
        catalogValues: [],
        variant: undefined,
        validations: [
            {
                value: '50',
                typeValidation: 'VAL_LENGTH_MAX',
                errorMessage: 'La longitud m\u00E1xima debe de ser de 50 caracteres',
            },
        ],
    },
    {
        fieldId: 76,
        idOrder: 4,
        label: 'CP',
        gridSize: 4,
        attrName: 'zipCodeNat',
        typeElement: 'TEXT',
        required: true,
        hidden: false,
        disable: false,
        catalog: null,
        catalogValues: [],
        variant: undefined,
        validations: [
            {
                value: '^\\d{5}$',
                typeValidation: 'VAL_REGEX',
                errorMessage: 'CP ingresado es incorrecto',
            },
            {
                value: '50',
                typeValidation: 'VAL_LENGTH_MAX',
                errorMessage: 'La longitud m\u00E1xima debe de ser de 50 caracteres',
            },
        ],
    },
    {
        fieldId: 77,
        idOrder: 5,
        label: 'Colonia',
        gridSize: 6,
        attrName: 'colonyKeyNat',
        typeElement: 'SELECT',
        required: false,
        hidden: false,
        disable: false,
        catalog: 'CAT_SEPOMEX',
        catalogValues: [],
        variant: undefined,
        validations: [],
    },
    {
        fieldId: 78,
        idOrder: 6,
        label: 'Municipio/Delegaci\u00F3n',
        gridSize: 6,
        attrName: 'municipalityDescriptionNat',
        typeElement: 'TEXT',
        required: true,
        hidden: false,
        disable: false,
        catalog: null,
        catalogValues: [],
        variant: undefined,
        validations: [
            {
                value: '50',
                typeValidation: 'VAL_LENGTH_MAX',
                errorMessage: 'La longitud m\u00E1xima debe de ser de 50 caracteres',
            },
        ],
    },
    {
        fieldId: 79,
        idOrder: 7,
        label: 'Estado',
        gridSize: 6,
        attrName: 'stateKeyNat',
        typeElement: 'SELECT',
        required: true,
        hidden: false,
        disable: false,
        catalog: 'CAT_ESTADOS',
        catalogValues: [],
        variant: undefined,
        validations: [],
    },
    {
        fieldId: 80,
        idOrder: 8,
        label: 'Pa\u00EDs',
        gridSize: 6,
        attrName: 'countryKeyNat',
        typeElement: 'SELECT',
        required: true,
        hidden: false,
        disable: true,
        catalog: 'CAT_PAISES',
        catalogValues: [],
        variant: undefined,
        validations: [],
    },
];

